
export let setCookie = (cname, cvalue, exdays) => {
  let d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = 'expires='+d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
};

export let getCookie = (cname, dval = '', dexp = 365) => {
  let name = cname + '=';
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) ===' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  if (dval!=='') {
    setCookie(cname,dval,dexp);
  }
  return dval;
};

export let deleteCookie = (cname) => {
  // console.log('checking cookie: ' + cname);
  let expires = new Date(0).toUTCString();
  let darr = window.location.hostname.replace(/^www\./i, "").split('.').reverse();
  let domains = [];
  let domain = '';
  darr.forEach(function(item){
    domain = item + domain;
    domains.push(domain);
    domain = '.' + domain;
    domains.push(domain);
  });
  // console.log('domains: ' + JSON.stringify(domains));
  domains.forEach(function(domain){
    let toRemove = cname + "=; expires=" + expires + "; path=/; domain=" + domain;
    // console.log('removing cookie: ' + toRemove);
    document.cookie = toRemove;
  });
};

export let delete_cookies_except = (except = []) => {
  let cookies = document.cookie.split(";");
  // console.log('cookies: ' + JSON.stringify(cookies));
  // console.log('except: ' + JSON.stringify(except));
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    let cookie_array = cookie.split("=");
    let cookie_name = cookie_array[0].trim();
    if (cookie_name.length>0 && except.indexOf(cookie_name)<0) {
      deleteCookie(cookie_name);
    }
  }
};
